import {useFormikContext} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import {BottomSheet} from 'react-spring-bottom-sheet';

import CustomRadio from '../../../../../../components/mazraeKit/customRadio';
import {RootState} from '../../../../../../store/redux';
import {addRegisterAdvertisement} from '../../../../../../store/redux/advertisementRegisteration';
import {formulationTypesRadio} from '../../../constants';
import {FromikType, ICommon} from '../../../types';

interface IFormulationBottomSheet {
  openFormulationBottomSheet: boolean;
  setOpenFormulationBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
}

function FormulationBottomSheet({
  openFormulationBottomSheet,
  setOpenFormulationBottomSheet,
}: IFormulationBottomSheet) {
  const {input_group} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );
  const {setFieldValue, values} = useFormikContext<FromikType>();

  const dispatch = useDispatch();
  return (
    <BottomSheet
      onDismiss={() => setOpenFormulationBottomSheet(false)}
      open={openFormulationBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col gap-3 px-3 pb-3">
        {input_group?.code &&
          formulationTypesRadio[input_group?.code]?.map((item: ICommon) => (
            <CustomRadio
              {...item}
              name="radio"
              value={item?.value}
              key={item?.value}
              checked={item?.value === values?.type?.value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue('type', {
                  title: item?.title,
                  value: e.target.value,
                });
                dispatch(
                  addRegisterAdvertisement({
                    type: {
                      title: item?.title,
                      value: e?.target?.value,
                    },
                  }),
                );
                setOpenFormulationBottomSheet(false);
              }}
            />
          ))}
      </div>
    </BottomSheet>
  );
}

export default FormulationBottomSheet;
